import React, {useEffect} from "react";
import InputAdvancementFormik from "../../inputs/InputAdvancementFormik";
import {useDispatch, useSelector} from "react-redux";
import ExitButton from "../../buttons/ExitButton";
import CriticalityRadioButton from "../../inputs/CriticalityRadioButton";
import {loadProject} from "../../project/one-project/projectAction";
import styled, {css} from "styled-components";
import {BaseModal} from "../modalStyle";
import {loadUsers} from "../../user/usersAction";
import {loadProjects} from "../../project/projects/projectsAction";
import {FunctionalModal} from "../FunctionalModal";
import {DisplayForHead,} from "../../../permissions/DisplayAccordingToRole";
import {CLEAR_USERS} from "../../user/userTypes";
import SendFormButton from "../../buttons/SendFormButton";
import TagInput from "../../inputs/TagInput";
import {loadActions, patchOneOkrAction, postOneOkrAction} from "../../action/actionAction";
import useTags from "../../../custom-hooks/useTags";
import useSortItems from "../../../custom-hooks/useSortItems";
import {ErrorMessage, Field, Formik} from "formik";
import * as Yup from "yup";
import {FormFormik, InputTextFormik} from "../../inputs/InputStyle";
import SelectUserInputFormik from "../../inputs/SelectUserInputFormik";
import {CLEAR_OKR_ACTION} from "../../action/actionTypes";
import TextareaFormikInput from "../../inputs/TextareaFormikInput";
import {loadAllObjectives} from "../../objective/ObjectiveActions";

const ActionOkrModal = ({
                            setOpenModal,
                            selectedActionId,
                            inActionPage,
                            task = {},
                            keyResultsId
                        }) => {

    const dispatch = useDispatch()
    const currentUser = useSelector(state => state.currentUser)
    const {status: currentUserStatus} = useSelector(state => state.currentUser)
    const {projects} = useSelector(state => state.projects)
    const project = useSelector(state => state.project)
    const {sortOneItemTopOfTheList, pushItemsInArray, returnRemovedItems, returnAddedItems} = useSortItems()
    const {users} = useSelector(state => state.users)


    const {
        name,
        criticality,
        deadline,
        startDate,
        advancement,
        comment,
        pilot: actionPilot,
        projectId: projectIdInAction,
        status,
        tags
    } = useSelector(state => state.action)

    const {selectedTags, setSelectedTags} = useTags(projects, tags)

    useEffect(() => {
        return () => {
            dispatch({type: CLEAR_USERS})
            dispatch({type: CLEAR_OKR_ACTION})
        }
    }, [dispatch, inActionPage])

    useEffect(() => {
        dispatch(loadUsers())
    }, [dispatch])


    useEffect(() => {
        if (inActionPage) {
            dispatch(loadProjects())
        }
    }, [currentUser.roles, dispatch, inActionPage, selectedActionId])

    useEffect(() => {
        if (projectIdInAction && inActionPage) {
            dispatch(loadProject(projectIdInAction))
        }
    }, [currentUserStatus, dispatch, inActionPage, projectIdInAction, status])


    const displayTaskName = () => {
        if (selectedActionId === 0) {
            if (Object.keys(task).length > 0) {
                return task.content
            } else {
                return ""
            }
        } else {
            return name
        }
    }
    const displayTaskComment = () => {
        if (selectedActionId === 0) {
            if (Object.keys(task).length > 0) {
                return `Cette action a été générée suite à l'idée de ${task.author.firstName} ${task.author.lastName}`
            } else {
                return ""
            }
        } else {
            return comment ? comment : ""
        }
    }

    const addTagsToData = (newData) => {
        // Handle tags : if we create an action we push all the tags selected otherwise we filter according to the existing tags
        if (selectedActionId === 0) {
            if (selectedTags.length > 0) {
                newData.tags = pushItemsInArray(selectedTags, "tagId")
            }
        } else {
            let keyName = "tagId"
            let removedTags = returnRemovedItems(selectedTags, tags, keyName)
            let addedTags = returnAddedItems(selectedTags, tags, keyName)

            if (removedTags) {
                newData.removeTags = removedTags
            }
            if (addedTags) {
                newData.tags = addedTags
            }
        }
    }
    const handleSubmit = async (data) => {
        const newData = Object.assign({}, data)
        newData.executorId = Number(data.pilotId)
        newData.criticality = Number(data.criticality)
        delete newData.pilotId
        addTagsToData(newData)
        if (selectedActionId !== 0) {
            await dispatch(patchOneOkrAction(selectedActionId, newData));
        } else {

            await dispatch(postOneOkrAction(keyResultsId,newData));
            if(project.id !== 0){
                await dispatch(loadProject(project.id))
            }
        }
        if(inActionPage){
            await dispatch(loadActions(currentUser.id))
        }
        if(project.id !== 0){
            await dispatch(loadProject(project.id))
        }
        await dispatch(loadAllObjectives(currentUser.id))
        closeUpdate()
    };

    const closeUpdate = () => {
        setOpenModal(false);
    }


    const displayMembers = () => {
        let newUsersArray
        if (selectedActionId !== 0) {
            newUsersArray = sortOneItemTopOfTheList(users, actionPilot)
        } else {
            newUsersArray = users
        }
        return newUsersArray
    }


    const ActionOkrSchema = Yup.object().shape({
        name: Yup.string()
            .min(2, "Le nom de l'action est trop court")
            .max(255, "Le nom de l'action est trop long")
            .required("Le nom de l'action  est requis"),
        comment: Yup.string()
            .min(2, "Le commentaire doit avoir au moins 2 caractères")
            .max(1000, "Le commentaire ne doit pas dépasser 1000 caractères"),
        // advancement: Yup.number(),
        criticality: Yup.number(),
        deadline: Yup.string(),
        startDate: Yup.string(),
        pilotId: Yup.string()
            .required("Il est obligatoire de choisir un pilote"),
    })

    return (
        <FunctionalModal
            setOpen={setOpenModal}
            component={
                <Modal $mode={inActionPage && selectedActionId === 0 ? "big" : ""}>
                    <div className="flex-row">
                        <h1> {selectedActionId ? "Modifier l'action " : "Ajouter une action"} </h1>
                        <ExitButton
                            closeUpdate={closeUpdate}
                        />
                    </div>
                    <Formik
                        enableReinitialize
                        initialValues={{
                            name: displayTaskName(),
                            pilotId: selectedActionId ? actionPilot?.id?.toString() : "",
                            comment: displayTaskComment(),
                            criticality: selectedActionId ? criticality : 1,
                            advancement: selectedActionId ? advancement : 0,
                            deadline: selectedActionId ? deadline ? deadline : "" : "",
                            startDate: selectedActionId ? startDate ? startDate : "" : "",
                        }}
                        validationSchema={ActionOkrSchema}
                        onSubmit={handleSubmit}
                    >
                        {({isValid, isSubmitting, values}) => (
                            <Form>
                                <SendFormButton
                                    state={isValid && !isSubmitting}
                                    actionName={selectedActionId ? "Enregistrer " : "Créer"}
                                />
                                <div>
                                    <label htmlFor="name"> Nom de l'action * </label>
                                    <InputText
                                        name="name"
                                        type={"text"}
                                        placeholder={"Nom de l'action"}
                                    />
                                    <ErrorMessage
                                        name="name"
                                        render={msg => <div><p className="error-text"> {msg} </p></div>}
                                    />
                                </div>
                                <DisplayForHead
                                    hasException={(project.pilot.id === currentUser.id) || (project.copilot ? project.copilot.id === currentUser.id : false) || (project.axisSponsor ? project.axisSponsor.id === currentUser.id : false)}
                                    component={
                                        <>
                                            <SelectUserInputFormik
                                                pilotId={values.pilotId}
                                                users={displayMembers()}
                                                label={"responsable"}
                                            />
                                            <ErrorMessage
                                                name="pilotId"
                                                render={msg => <div><p className="error-text"> {msg} </p></div>}
                                            />
                                        </>
                                    }
                                />
                                <div className={"flex-col gap-05"}>
                                    <label htmlFor="comment"> Commentaire </label>
                                    <TextareaFormikInput
                                        name="comment"
                                        rows="4"
                                        placeholder="Écrivez votre commentaire"
                                    />
                                    <ErrorMessage
                                        name="comment"
                                        render={msg => <div><p className="error-text"> {msg} </p></div>}
                                    />
                                </div>

                                <DisplayForHead
                                    hasException={(project.pilot.id === currentUser.id) || (project.copilot ? project.copilot.id === currentUser.id : false) || (project.axisSponsor ? project.axisSponsor.id === currentUser.id : false)}
                                    component={
                                        <TagInput
                                            isLimitedItem={true}
                                            setSelectedTags={setSelectedTags}
                                            selectedTags={selectedTags}
                                            actionName={'actions'}
                                        />}
                                />

                                <DisplayForHead
                                    hasException={(project.pilot.id === currentUser.id) || (project.copilot ? project.copilot.id === currentUser.id : false) || (project.axisSponsor ? project.axisSponsor.id === currentUser.id : false)}
                                    component={
                                        <DateContainer>
                                            <Date>
                                                <label htmlFor="startDate"> Date de début </label>
                                                <Field
                                                    name="startDate"
                                                    type={"date"}
                                                />
                                            </Date>
                                            <Date>
                                                <label htmlFor="deadline"> Échéance </label>
                                                <Field
                                                    name="deadline"
                                                    type={"date"}
                                                />
                                            </Date>
                                            <ErrorMessage
                                                name="deadline"
                                                render={msg => <div><p className="error-text"> {msg} </p></div>}
                                            />
                                        </DateContainer>
                                    }/>
                                <DisplayForHead
                                    hasException={(project.pilot.id === currentUser.id) || (project.copilot ? project.copilot.id === currentUser.id : false) || (project.axisSponsor ? project.axisSponsor.id === currentUser.id : false)}
                                    component={
                                        <CriticalityRadioButton
                                            criticality={values.criticality}
                                            displayLabel={true}
                                            mandatoryField={true}
                                        />}
                                />

                                <InputsContainer>
                                    <label> Avancement </label>
                                    <InputAdvancementFormik
                                        advancementSelection={values.advancement}
                                    />
                                </InputsContainer>
                            </Form>
                        )}

                    </Formik>
                </Modal>}
        />

    )
}

const Modal = styled(BaseModal)`
  position: unset;
  width: 100%;
  gap: 1rem;
  overflow-y: auto;
  inset: unset;

  h1 {
    width: 100%;
    text-align: center;

  }


  ${(props) => {
    switch (props.$mode) {
        case "big":
            return css`
          height: calc(100% - 20px);
        `;
        default:
            return css`
        `;
    }
}}
}

@media (min-width: 900px ) {
  border-radius: 15px;
  width: 550px;
  left: 0;
  right: 0;
  ${(props) => {
    switch (props.$mode) {
        case "big":
            return css`
          height: fit-content;
        `;
        default:
            return css`
          position: absolute;
          margin: auto;
        `;
    }
}}
}
`


const DateContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 1rem;
`
const Date = styled.div`
  display: flex;
  gap: 0.5rem;
  align-items: center;
  white-space: nowrap;
`


const Form = styled(FormFormik)`
  input[type="date"] {
    width: initial;
  }

  .criticality-input {
    border: 1px solid rgba(166, 172, 181, 0.6);
  }
`

const InputText = styled(InputTextFormik)`
`

const InputsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5em;
  padding: 0.5em;
  border-radius: 10px;

  label {
    font-weight: 700;
  }`

export default ActionOkrModal;
